import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=e2c1cbc8&scoped=true"
import script from "./divider.vue?vue&type=script&lang=js"
export * from "./divider.vue?vue&type=script&lang=js"
import style0 from "./divider.vue?vue&type=style&index=0&id=e2c1cbc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c1cbc8",
  null
  
)

export default component.exports